import { gql } from 'graphql-request';
import { PayrollUpdatePayResponse, PayrollValidatePayResponse, UpdatePayRequest } from './types';
import { graphQLApi } from 'utils/Api';

const updatePayMutation = gql`
  mutation PayrollReviseSalary($userId: String!, $payload: SalaryStructurePayload!) {
    payrollReviseSalary(userId: $userId, payload: $payload) {
      code
      success
      message
      data {
        success
      }
    }
  }
`;

const validatePayMutation = gql`
  mutation PayrollValidateSalary($userId: String!, $payload: SalaryStructurePayload!) {
    payrollValidateSalary(userId: $userId, payload: $payload) {
      code
      success
      message
      data {
        annualSalary
        arrears {
          name
          amount
        }
        monthWiseBreakdown
        arrearMonth
        existingArrearsDistribution {
          name
          value
        }
        salaryModelValidation
      }
    }
  }
`;

const updatePay = (queryVariables: UpdatePayRequest) => {
  return graphQLApi<PayrollUpdatePayResponse, UpdatePayRequest>({
    query: updatePayMutation,
    queryVariables,
  });
};

const validatePay = (queryVariables: UpdatePayRequest) => {
  return graphQLApi<PayrollValidatePayResponse, UpdatePayRequest>({
    query: validatePayMutation,
    queryVariables,
  });
};

export default {
  updatePay,
  validatePay,
};
